import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms'
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { Router } from '@angular/router';
import * as sha512 from 'js-sha512';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoginService } from '../login.service';
import { HeaderService } from 'src/app/core/header/header.service';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})

export class ChangePasswordComponent implements OnInit {
  resetPasswordFormGroup!: UntypedFormGroup;
  public isResetFormSubmitted: boolean = false;
  public errorMessage: any = null;
  private router: Router;
  public showLoader: boolean = false;
  public title: string | undefined;
  menuDetails: any;
  public successCount : number = 0;

  @Output() sendResponse: EventEmitter<any> = new EventEmitter();

  get resetPasswordForm() {
    return this.resetPasswordFormGroup.controls;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    public bsModalRef: BsModalRef,
    private errorHandler: ErrorHandlerService,
    router: Router,
    private userService: UserService,
    private loginService: LoginService,
    private headerService: HeaderService) {
    this.router = router;
  }
  ngOnInit() {
    this.resetPasswordFormGroup = this.formBuilder.group({
      password: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{6,}")]],
      confirmPassword: ['', [Validators.required]],
    });

  }

  ConfirmPasswordChange() {
    if (this.resetPasswordFormGroup.controls['newPassword'].value === this.resetPasswordFormGroup.controls['confirmPassword'].value) {
      this.resetPasswordFormGroup.controls['confirmPassword'].clearValidators();
      this.resetPasswordFormGroup.controls['confirmPassword'].updateValueAndValidity();
    }
    else {
      this.resetPasswordFormGroup.controls['confirmPassword'].setErrors(
        { 'notMatched': true }
      );
    }
    this.ValidateOldPassword();
  }

  ValidateOldPassword() {
    if (this.resetPasswordFormGroup.controls['password'].value === this.resetPasswordFormGroup.controls['newPassword'].value) {
      this.resetPasswordFormGroup.controls['newPassword'].setErrors(
        { 'oldPasswordMatched': true }
      );
    }
    else {
      this.resetPasswordFormGroup.controls['newPassword'].clearValidators();
      this.resetPasswordFormGroup.controls['newPassword'].setValidators([Validators.required, Validators.minLength(6), Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{6,}")]);
      this.resetPasswordFormGroup.controls['newPassword'].updateValueAndValidity();
    }
  }

  Close() {
    this.bsModalRef.hide();
  }

  SendResponse() {
   
    this.errorMessage = null;
    this.isResetFormSubmitted = true;
    if (this.resetPasswordFormGroup.invalid) {
      return;
    }
    this.showLoader = true;
    let passwordDetail = {
      oldPassword: sha512.sha512.hex(this.resetPasswordFormGroup.controls['password'].value),
      password: sha512.sha512.hex(this.resetPasswordFormGroup.controls['newPassword'].value),
    }
    this.isResetFormSubmitted = false;
    this.loginService.ResetPassword(passwordDetail).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        if (data.ErrorViewModel) {
          if (data.ErrorViewModel.Code) {
            this.errorMessage = this.errorHandler.GetErrorMessage("ResetPassword", data.ErrorViewModel.Code);
          }
        }
        else {
          if (this.title == 'Reset Password') {
            let user = {
              "UserMasterID": data.Data.UserMasterID,
              "FirstName": data.Data.FirstName,
              "LastName": data.Data.LastName,
              "ClientMasterID": data.Data.ClientMasterID
            }
            sessionStorage.setItem("user", JSON.stringify(user));
            //localStorage.setItem("user", JSON.stringify(user));
            this.headerService.SetUserData(data.Data);
            for (let i = 1; i <= 11; i++) {
              this.GetUserPermissions(data.Data.UserMasterID, i);
            }
            // this.router.navigateByUrl('/Workbench');
            this.bsModalRef.hide();
          }
          else {
            this.bsModalRef.hide();
            this.loginService.Logout().subscribe({
              next: (data: any) => {
                sessionStorage.clear();
                localStorage.clear();
                this.router.navigateByUrl("/Login");
              }, error: (error: any) => {
                sessionStorage.clear();
                localStorage.clear();
                this.router.navigateByUrl("/Login");
              }
            });
          }

        }
      }, error: (error: any) => {
        this.bsModalRef.hide();
        this.showLoader = false;
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigateByUrl("/Login");
        this.errorMessage = this.errorHandler.GetErrorMessage("ResetPassword", error.status);
      }
    });
  }
  GetUserPermissions(userId: number, menu: number) {
    let data = {
      ID: userId,
      MenuId: menu
    }
    this.showLoader = true;
    this.userService.GetUserPermissions(data).subscribe({
      next: (data: any) => {
        this.menuDetails = data.Data;
        this.successCount++;
        this.headerService.SetMenuData(this.menuDetails, menu,this.successCount);
        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("User", error.status);
        //this.notifier.notify('error', this.errorMessage);
      }
    });
  }
}
